'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function languageFromLocale(locale) {
  return locale.split('-')[0].toLowerCase();
}

exports.languageFromLocale = languageFromLocale;
